import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true, 
  imports:[],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  versao:String = environment.version;
}
